<template>
    <div class="logo">
        <router-link :to="{name: 'home'}" class="logo--title" tag="h1">Jia Szeto Paris</router-link>
        <router-link :to="{name: 'home'}" class="logo--subtitle" tag="h2">Stylist</router-link>
    </div>
</template>

<script>
export default {}
</script>


// WEBPACK FOOTER //
// src/components/Header.vue